import '@hotmart/cosmos/dist/table/table.css'
import '@hotmart/cosmos/dist/table/variations/borderless.css'
import '@hotmart/cosmos/dist/table/variations/card.css'
import '@hotmart/cosmos/dist/table/variations/hover.css'
import type { ReactNode } from 'react'

import clsx from 'clsx'

type TableProps = {
  children: ReactNode
  className?: string
  dataTest?: string
}

type TableHeadProps = {
  children?: ReactNode
  className?: string
}

type TableHeaderProps = {
  children: ReactNode
  className?: string
}

type TableDataProps = {
  colSpan?: number
  dataTest?: string
  children: ReactNode
  className?: string
}

type TableRowProps = {
  children: ReactNode
  className?: string
  dataTest?: string
}

const Table = ({ children, className, dataTest = '' }: TableProps) => (
  <table data-test={dataTest} className={clsx('hot-table', className)}>
    {children}
  </table>
)
const TableRow = ({ children, dataTest = '' }: TableRowProps) => (
  <tr data-test={dataTest}>{children}</tr>
)
const TableHead = ({ className, children }: TableHeadProps) => (
  <th className={className}>{children}</th>
)

const TableBody = ({ children }) => <tbody>{children}</tbody>

const TableData = ({ className, children, dataTest = '', colSpan = 1 }: TableDataProps) => (
  <td className={className} colSpan={colSpan} data-test={dataTest}>
    {children}
  </td>
)

const TableHeader = ({ className, children }: TableHeaderProps) => {
  return (
    <thead className={className}>
      <tr>{children}</tr>
    </thead>
  )
}

Table.Row = TableRow
Table.Head = TableHead
Table.Body = TableBody
Table.Data = TableData
Table.Header = TableHeader

export default Table
